import request from '../common/request.js';

//文件上传
export function Upload(payload) {
    return request.post('/Upload/Posts', payload);
}